import { styled } from "@mui/material";

export const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
}));
